import React, { useState, useEffect } from "react";
import {
  Table,
  Modal,
  Spinner,
  Alert,
  Form,
  ModalFooter,
  Badge,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import Paper from "@material-ui/core/Paper";
import Pagination from "@material-ui/lab/Pagination";
import MySelect from "./../../CustomChallan/MySelect";
import makeAnimated from "react-select/animated";
import { components } from "react-select";
import usePagination from "../../../../components/usePagination/usePagination";

export default function StudentsSubjectAssign() {
  const alert = useAlert();
  // configgration
  const authtoken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);

  //store data
  const dispatch = useDispatch();
  let campusidget = useSelector((state) => state.campuses.setselectedcampusid);

  //arrays
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [allcampus_classes, setallcampus_classes] = useState([]);
  const [allcampus_classe_sections, setallcampus_classe_sections] = useState(
    []
  );
  const [allsessions, setallsessions] = useState([]);
  const [allstudents, setallstudents] = useState([]);
  const [studentsForSubjectAssign, setstudentsForSubjectAssign] = useState([]);
  const [allcheckboxes, setallcheckboxes] = useState([]);
  const [allsubjects, setallsubjects] = useState([]);
  const [optionSelected, setoptionSelected] = useState([]);
  const [selectedsubjects, setselectedsubjects] = useState([]);
  //objects

  //strings
  const [previousselectedcampus, setpreviousselectedcampus] = useState(
    campusidget
  );
  const [selectedcampus, setselectedcampus] = useState("");
  const [selectedclass, setselectedclass] = useState("");
  const [selectedsection, setselectedsection] = useState("");
  const [currentsession, setcurrentsession] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage, setpostPerPage] = useState(10);
  const [searchtext, setsearchtext] = useState("");

  //booleans
  const [checkallcheckbox, setcheckallcheckbox] = useState(false);
  const [openmodal, setopenmodal] = useState(false);
  const [loader, setloader] = useState(false);
  const [isanysubject, setisanysubject] = useState(false);
  const [educationType, setEducationType] = useState(1);
  const [loading, setloading] = useState(false);

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");

  useEffect(() => {
    if (campusidget != "") {
      setpreviousselectedcampus(campusidget);
      onchangecampus(campusidget);
    }
    // getAllCampus();
    getAllSessions();
    getAllSubjects();
  }, []);

  //functions

  const assignSubjectsFun = (url) => {
    if (selectedsubjects.length == 0) {
      setisanysubject(true);
      return;
    }
    setloading(true);
    setisanysubject(false);
    let data = {
      subject_ids: selectedsubjects,
      student_ids: studentsForSubjectAssign,
    };

    fetch(`${baseUrl}/` + url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setloading(false);
        setopenmodal(false);
        setselectedsubjects([]);
        setoptionSelected([]);
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success("Successfully Assign");
            setstudentsForSubjectAssign([]);
            fetchStudents(
              campusId,
              courseId,
              classId,
              sectionId,
              currentsession
            );
          } else {
            alert.error("Error");
          }
        } else {
          alert.error("Error");
        }
      })
      .catch((err) => {
        alert.error("Error");
        setloading(false);
        setopenmodal(false);
        setselectedsubjects([]);
        setoptionSelected([]);
      });
  };

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsessions(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setcurrentsession(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllSubjects = () => {
    fetch(`${baseUrl}/subject`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsubjects(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = (id) => {
    if (id == "") {
      return alert.error("Please Select Campus");
    }
    fetch(`${baseUrl}/campus-all-courses/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = (id) => {
    if (id == "") {
      return alert.error("Please Select Course");
    }
    fetch(`${baseUrl}/course-all-classes/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSectionChange = (id) => {
    setSectionId(id);
    fetchStudents(campusId, courseId, classId, id, currentsession);
  };

  const fetchStudents = (
    campusId,
    courseId,
    classId,
    sectionId,
    currentsession
  ) => {
    setloader(true);
    setallstudents([]);
    let data = {
      campus_id: campusId,
      course_id: courseId,
      student_class_id: classId,
      global_section_id: sectionId,
      year_id: currentsession,
      status: 2,
    };

    fetch(`${baseUrl}/student_filter_list`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setloader(false);
        if (data.metadata) {
          if (data.metadata.success) {
            setallstudents([...data.payload]);
            let checkboxes = data.payload;
            data.payload.map((item, index) => {
              item["checked"] = false;
              checkboxes[index] = item;
            });
            setallstudents([...checkboxes]);
            setcheckallcheckbox(false);
          } else {
            alert.show("Error Occured");
          }
        } else {
          alert.show("Error Occured");
        }
      })
      .catch((err) => {
        setloader(false);
        alert.show("Error Occured");
        console.log(err);
      });
  };

  const onchangecampus = (id) => {
    setallcampus_classes([]);
    setallcampus_classe_sections([]);
    setallstudents([]);
    setselectedcampus(id);
    setselectedclass("");
    setselectedsection("");
    setpreviousselectedcampus(id);
    dispatch({
      type: "SELECTED_CAMPUS_ID",
      payload: {
        setselectedcampusid: id,
      },
    });
    fetch(`${baseUrl}/campusclass/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallcampus_classes([...data.payload]);
      })
      .catch((err) => {
        console.log("class", err);
      });
  };

  //paginaytion work
  const indexOfLastPost = currentPage * postPerPage;

  const indexOfFirstPost = indexOfLastPost - postPerPage;

  let dataSearch = allstudents.filter((user) => {
    let text = searchtext.toLowerCase();
    return searchtext
      ? user?.name?.toLowerCase().includes(text) ||
          user?.admission_id?.toLowerCase().includes(text)
      : true;
  });

  //check box work
  const allcheckboxChecked = () => {
    let middlearray = [];
    let studentarray = [];
    if (checkallcheckbox) {
      setcheckallcheckbox(false);
      allstudents.map((item, i) => {
        item.checked = false;
        middlearray.push(item);
      });
    } else {
      setcheckallcheckbox(true);
      allstudents.map((item, i) => {
        item.checked = true;
        studentarray.push(item.id);
        middlearray.push(item);
      });
    }
    setstudentsForSubjectAssign([...studentarray]);
    setallstudents([...middlearray]);
  };
  const checkBoxClick = (e, index) => {
    setcheckallcheckbox(true);
    let middlearray = [];
    let studentarray = [];
    allstudents.map((item, i) => {
      if (item.id == index) {
        item.checked = !item.checked;
      }
      if (!item.checked) {
        setcheckallcheckbox(false);
      }
      if (item.checked) {
        studentarray.push(item.id);
      }
      middlearray.push(item);
    });

    setstudentsForSubjectAssign([...studentarray]);
    setallstudents([...middlearray]);
  };
  //multiselect
  const animatedComponents = makeAnimated();
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };
  const MultiValue = (props) => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );

  const Options = [];
  allsubjects.map((item, index) => {
    Options[index] = { value: item.id, label: item.name };
  });

  const handleChangeSubjects = (selected) => {
    if (optionSelected.length == 30 && selected.length == 30) {
      setoptionSelected([]);
      return;
    }
    setoptionSelected([...selected]);
    let valuearray = [];

    selected.map((item, index) => {
      valuearray[index] = item.value;
    });
    setselectedsubjects([...valuearray]);
    if (valuearray.length == 0) {
      setisanysubject(true);
      return;
    }
    setisanysubject(false);
  };

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(dataSearch.length / PER_PAGE);
  const _DATA = usePagination(dataSearch, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const removeSubject = () => {
    setloading(true);
    setisanysubject(false);
    let data = {
      subject_ids: "",
      student_ids: studentsForSubjectAssign,
    };

    fetch(`${baseUrl}/subjects_assign_student`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setloading(false);
        setopenmodal(false);
        setselectedsubjects([]);
        setoptionSelected([]);
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success("Successfully Removed");
            setstudentsForSubjectAssign([]);
            fetchStudents(
              campusId,
              courseId,
              classId,
              sectionId,
              currentsession
            );
          } else {
            alert.error("Error");
          }
        } else {
          alert.error("Error");
        }
      })
      .catch((err) => {
        alert.error("Error");
        setloading(false);
        setopenmodal(false);
        setselectedsubjects([]);
        setoptionSelected([]);
      });
  };
  const removeSubject2 = () => {
    if (selectedsubjects.length == 0) {
      alert.error("Please Select At Least 1 Subject");
      return;
    }
    setloading(true);
    setisanysubject(false);
    let data = {
      subject_ids: selectedsubjects,
      student_ids: studentsForSubjectAssign,
    };

    fetch(`${baseUrl}/remove-subjects-student`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setloading(false);
        setopenmodal(false);
        setselectedsubjects([]);
        setoptionSelected([]);
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success("Successfully Removed");
            setstudentsForSubjectAssign([]);
            fetchStudents(
              campusId,
              courseId,
              classId,
              sectionId,
              currentsession
            );
          } else {
            alert.error("Error");
          }
        } else {
          alert.error("Error");
        }
      })
      .catch((err) => {
        alert.error("Error");
        setloading(false);
        setopenmodal(false);
        setselectedsubjects([]);
        setoptionSelected([]);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <button
          style={{
            width: "150px",
            color: "#ffffff",
            backgroundColor: "#121291",
            borderColor: "#121291",
          }}
          onClick={() => {
            if (studentsForSubjectAssign.length == 0) {
              alert.show("Please Select Some Students");
            } else {
              setopenmodal(true);
            }
          }}
          className="btn btn-success "
        >
          Assign/ReAssign
        </button>

        <br />
        <br />

        <div className="form-group row">
          <div className="form-group col-sm-6 flex-column d-flex">
            <label>
              <b>
                Select Session <span style={{ color: "red" }}>*</span>
              </b>
            </label>
            <select
              onChange={(e) => setcurrentsession(e.target.value)}
              className="form-select"
              style={{ height: 40 }}
              value={currentsession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allsessions.map((session, index) => (
                <option key={index} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex flex-column col-sm-6  ">
            <label>
              <b>Search</b>
            </label>
            <input
              onChange={(e) => setsearchtext(e.target.value)}
              id="searchInput"
              className="form-control "
              placeholder="Enter Challan Number or Name or Addmission ID"
            />
          </div>
        </div>
        {currentsession != "" ? (
          <div>
            <div className="row">
              <div className="col-md-3">
                <label>
                  <b>Select Campus </b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  onChange={(e) => onCampusChange(e.target.value)}
                  className="form-select"
                  style={{ backgroundColor: "white", height: 40 }}
                  value={campusId}
                  aria-label="Default select example"
                >
                  <option value="">Select Campus</option>
                  {campuses.map((campus, index) => (
                    <option key={index} value={campus.id}>
                      {campus.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-3">
                <label>
                  <b>Select Course </b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-select form-control"
                  name="course_id"
                  value={courseId}
                  onChange={(e) => onCourseChange(e.target.value)}
                  style={{ backgroundColor: "white", height: 40 }}
                  aria-label="Default select example"
                >
                  <option value="">Select Course</option>
                  {campusCourseData.map((item, index) => (
                    <option key={index} value={item.course?.id}>
                      {item.course?.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-3">
                <label>
                  <b>Select Class </b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-select form-control"
                  name="class_id"
                  value={classId}
                  onChange={(e) => onClassChange(e.target.value)}
                  style={{ backgroundColor: "white", height: 40 }}
                  aria-label="Default select example"
                >
                  <option value="">Select Class</option>
                  {courseClassData.map((item, index) => (
                    <option key={index} value={item.class?.id}>
                      {item.class?.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-3">
                <label>
                  <b>Select Section </b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="form-select form-control"
                  name="section_id"
                  value={sectionId}
                  onChange={(e) => onSectionChange(e.target.value)}
                  style={{ backgroundColor: "white" }}
                  aria-label="Default select example"
                >
                  <option value="">Select Section</option>
                  {classSectionData.map((item, index) => (
                    <option key={index} value={item.section?.id}>
                      {item.section?.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {loader ? (
              <div className="row justify-content-center">
                {" "}
                <span className="spinner-border"></span>{" "}
              </div>
            ) : (
              <Table responsive className="mt-5">
                <thead>
                  <tr>
                    <th>Student Name</th>
                    <th>Father Name</th>
                    <th>Admission Id</th>

                    <th>Assinged Subjects</th>
                    <th>
                      <input
                        onClick={(e) => {
                          allcheckboxChecked();
                        }}
                        checked={checkallcheckbox}
                        placeholder="Checkbox"
                        type="checkbox"
                        readOnly
                      />{" "}
                      <span style={{ marginleft: "15px" }}>Check All</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {_DATA.currentData().map((student, index) => (
                    <tr key={student.id}>
                      <td
                        title={student.name.length > 15 ? student.name : null}
                        style={{ textAlign: "start", cursor: "pointer" }}
                      >
                        {student.name}
                      </td>
                      <td
                        title={
                          student.father_name.length > 15
                            ? student.father_name
                            : null
                        }
                        style={{ textAlign: "start", cursor: "pointer" }}
                      >
                        {student.father_name.length > 15
                          ? student.father_name.substring(0, 12) + "..."
                          : student.father_name}
                      </td>

                      {/* <td style={{ textAlign: "start" }}>{feechallan.father_name}</td> */}
                      <td style={{ textAlign: "start" }}>
                        {student.admission_id}
                      </td>

                      <td style={{ textAlign: "start" }}>
                        {student.subjects.map((subject, index) => {
                          return (
                            <Badge
                              key={index}
                              style={{
                                backgroundColor: "black",
                                marginRight: "2px",
                              }}
                              bg="primary"
                            >
                              {subject.name}
                            </Badge>

                            // <span className="label label-default">
                            //     {subject.name}
                            // </span>
                          );
                        })}
                        {/* {feechallan.global_section_name} */}
                      </td>

                      <td style={{ textAlign: "start" }}>
                        <input
                          onClick={(e) => {
                            checkBoxClick(e, student.id);
                          }}
                          checked={student.checked}
                          value={allcheckboxes[index]}
                          type="checkbox"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
            <Pagination
              color="primary"
              count={count}
              size="large"
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
            />
          </div>
        ) : null}
      </Paper>

      <Modal size="lg" show={openmodal}>
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Assign or ReAssign Subjects
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <button className="btn-primary mb-5" onClick={removeSubject}>
            Remove All Subjects
          </button>
          <button className="btn-primary mb-5 mx-4" onClick={removeSubject2}>
            Remove Subjects
          </button>
          <div className="form-group col-sm-12 flex-column d-flex">
            <label>
              <b>
                Select subjects <span style={{ color: "red" }}>*</span>
              </b>
            </label>
            <MySelect
              options={Options}
              isMulti
              name="selectedOptions"
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              components={{ Option, MultiValue, animatedComponents }}
              onChange={handleChangeSubjects}
              allowSelectAll={true}
              value={optionSelected}
            />
          </div>

          {/* isanysubject */}
        </Modal.Body>
        {isanysubject ? (
          <>
            <Alert
              variant="danger"
              onClose={() => setisanysubject(false)}
              dismissible
            >
              <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
              <p>Please Add Some Subject</p>
            </Alert>
          </>
        ) : null}

        <Modal.Footer>
          {loading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                padding: "15px",
              }}
            >
              {" "}
              <span className="spinner-border"></span>{" "}
            </div>
          ) : (
            <>
              <button
                onClick={() => {
                  assignSubjectsFun("subjects_assign_student_without_detach");
                }}
                className="btn btn-success button_blue "
              >
                Assign
              </button>

              <button
                onClick={() => {
                  assignSubjectsFun("subjects_assign_student");
                }}
                className="btn btn-success button_blue "
              >
                ReAssign
              </button>
              <button
                onClick={() => {
                  setloading(false);
                  setopenmodal(false);
                  setselectedsubjects([]);
                  setoptionSelected([]);
                }}
                className="btn btn-danger btn_width"
              >
                Cancel
              </button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}
